import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "是否自动成团：", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "拼团设置" }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_a_select, {
          ref: "select",
          value: _ctx.automatic,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.automatic) = $event)),
          style: {"width":"200px","margin-left":"0px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select_option, { value: 12 }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 13 }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_a_button, {
          type: "primary",
          style: {"margin-left":"10px"},
          onClick: _ctx.setIndex
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    })
  ]))
}